// The sidebar's "New" dot: the newest publishedat the user has opened the feed
// with, kept per browser. ISO strings with a trailing Z compare lexically, so
// no Date parsing — both sides are API strings, never reformatted.
export const SEEN_KEY = 'releaseNotesLastSeen';
export const SEEN_EVENT = 'releasenotes:seen';

export const getLastSeen = () => {
  try {
    return window.localStorage.getItem(SEEN_KEY) || null;
  } catch {
    return null;
  }
};

export const markReleaseNotesSeen = (iso) => {
  if (!iso) return;
  try {
    const previous = getLastSeen();
    if (!previous || iso > previous) window.localStorage.setItem(SEEN_KEY, iso);
  } catch {
    // Private mode or a full quota: the dot simply stays; nothing else depends on it.
  }
  try {
    window.dispatchEvent(new Event(SEEN_EVENT));
  } catch {
    // jsdom without Event is not a case we meet; swallow to keep the page up.
  }
};

export const isUnread = (newestPublishedAt, lastSeen) =>
  Boolean(newestPublishedAt) && (!lastSeen || newestPublishedAt > lastSeen);
